// 商品订单列表
export default {
    heard_title: "商品订单列表",
    btn_createOrder: "创建订单",
    btn_close: "关闭",
    btn_refund: "退款",
    btn_print: "打印小票",
    // 关闭弹出框
    dt_closeOrder: "关闭订单",
    dp_memo: "请输入备注内容",
    // 提示相关
    confirm_refund: "此操作将直接退款到账, 是否继续?",
    sm_refund: "退款提交成功",
    em_refund: "退款提交失败",
    im_refund: "已取消退款",
    sm_print: "打印成功",
    em_print: "打印失败"
};
